
<template>
    <component v-bind:is="layout"/>
</template>

<script>
  const defaultLayout = 'common-layout';

  import CommonLayout from "./views/layouts/CommonLayout";
  import LoginLayout from "./views/layouts/LoginLayout";
  import { useToast } from "vue-toastification";
  import { handlePendingPaymentReturn } from "./utilities/paymentReturn";
  import { checkInvoiceWithRetry, takePendingAtmosInvoiceId } from "./utilities";

  export default {
    name: 'App',
    components: { CommonLayout, LoginLayout },
    setup() {
      const toast = useToast();
      return { toast }
    },
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout)
      },
    },
    mounted() {
      this.$store.commit('INIT_API_PARAMS')
      this.$store.dispatch('loadSettings')
      window.addEventListener('fitbase-auth-changed', this.syncAuthState)
      window.addEventListener('storage', this.syncAuthState)
      this.syncAuthState()
      this.resumePendingAtmosPayment()
      this.showPendingPaymentResult()
    },
    beforeUnmount() {
      window.removeEventListener('fitbase-auth-changed', this.syncAuthState)
      window.removeEventListener('storage', this.syncAuthState)
    },
    watch: {
      '$store.state.token': function() {
        if (this.$store.getters.token !== ''){
          this.$store.dispatch('loadUser')
        }
      },
    },
    methods: {
      // Клиент вернулся со страницы эквайринга: показываем итог оплаты, начатой до ухода
      async showPendingPaymentResult() {
        const result = await handlePendingPaymentReturn(this.$api, this.$store)

        if (!result) {
          return
        }

        if (!result.paid) {
          this.toast.error(result.message)
          return
        }

        if (result.message) {
          this.$store.commit('SHOW_SUCCESS_MODAL', result.message)
        }
      },
      syncAuthState() {
        const token = localStorage.getItem('fitbase_token') || ''

        if (this.$store.state.token === token) {
          return
        }

        this.$store.commit('SET_TOKEN', token)
      },
      async resumePendingAtmosPayment() {
        if (window.opener) {
          return
        }

        const invoiceId = takePendingAtmosInvoiceId()
        if (!invoiceId) {
          return
        }

        try {
          await checkInvoiceWithRetry(this.$api, invoiceId, 1)
          this.toast.success('Оплата прошла успешно')
          this.$store.dispatch('loadUser')
          this.$store.dispatch('loadContracts')
          this.$store.dispatch('loadServices')
        } catch (error) {
          this.toast.error('Не удалось подтвердить оплату. Проверьте статус в разделе «Мои абонементы и услуги»')
        }
      }
    }
  }
</script>

<style lang="sass">
  @import "assets/sass/main"
</style>
